import { render } from "./AnketaModal.vue?vue&type=template&id=6a85d6a2"
import script from "./AnketaModal.vue?vue&type=script&lang=js"
export * from "./AnketaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__